import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const featuredServices = [{
  title: 'Same Day Dentures',
  description: 'Ask us about our same day Digital Dentures',
  icon: 'https://cdn.magicpatterns.com/uploads/aZ3KKUNWgCriR5QPZAckb7/Same-Day-Dentures.png',
  bgColor: 'bg-[#cef4d2]/40'
}, {
  title: 'Dental Implant Consultation',
  description: 'We offer free Implant consultation',
  icon: 'https://cdn.magicpatterns.com/uploads/fx45GNNboFbZ12VpgNyMfh/Dental_Implant.png',
  bgColor: 'bg-[#4bafbc]/20'
}, {
  title: 'Teeth Whitening',
  description: 'We offer same day in office whitening as well',
  icon: 'https://cdn.magicpatterns.com/uploads/1vKdz7qfeGpqmfyNj7KGDo/teeth_white.png',
  bgColor: 'bg-[#cef4d2]/40'
}, {
  title: 'Root Canal',
  description: 'Ask us about root canals and extractions',
  icon: 'https://cdn.magicpatterns.com/uploads/iL13e8fbmPAFrdRMFqek4N/root-canal.png',
  bgColor: 'bg-[#4bafbc]/20'
}, {
  title: 'Braces/Orthodontic Treatment',
  description: 'Ask us about our same day braces and NO DOWNPAYMENT to start treatment once approved',
  icon: 'https://cdn.magicpatterns.com/uploads/rPiN8VnRnm6ZhhWhpyxMpm/BracesOrthodontic_Treatment.png',
  bgColor: 'bg-[#cef4d2]/40'
}, {
  title: 'Invisalign Consultation',
  description: 'We are proud to offer same day Clear Aligners',
  icon: 'https://cdn.magicpatterns.com/uploads/4heEDNCDizCiJ7T9qkNGSG/Invisalign-Consultation.png',
  bgColor: 'bg-[#4bafbc]/20'
}, {
  title: 'Veneers/Crowns/Bridges',
  description: 'We are the home of same day Ceramic Veneers and also Ceramic crowns',
  icon: 'https://cdn.magicpatterns.com/uploads/7iZVCXEnEs62UV1wTjURKP/Veneers-Crowns-Bridges.png',
  bgColor: 'bg-[#cef4d2]/40'
}];
export function FeaturedServices() {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Duplicate services for infinite loop effect
  const duplicatedServices = [...featuredServices, ...featuredServices];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => {
        const next = prev + 1;
        // Reset to 0 when we reach the end of the first set
        if (next >= featuredServices.length) {
          return 0;
        }
        return next;
      });
    }, 4000); // Slow slide every 4 seconds
    return () => clearInterval(interval);
  }, []);
  return <section className="relative py-24 overflow-hidden" data-id="element-98">
      {/* Background with subtle overlay */}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mXdoHQtv7c5Cyxcmk8D11m/pasted-image.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-99" />

      <div className="relative z-10 max-w-7xl mx-auto px-4" data-id="element-100">
        <div className="text-center mb-16 space-y-4" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-[#54c595] text-white px-4 py-1.5 rounded-full shadow-sm" data-id="element-102">
            <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center" data-id="element-103">
              <img src="https://cdn.magicpatterns.com/uploads/1vKdz7qfeGpqmfyNj7KGDo/teeth_white.png" alt="" className="w-4 h-4 brightness-0 invert" data-id="element-104" />
            </div>
            <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-105">
              Our Services
            </span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold text-[#4bafbc] tracking-tight" data-id="element-106">
            Gentle Care for Sparkling Smiles
          </motion.h2>
        </div>

        {/* Slider Container */}
        <div className="overflow-hidden mb-12" data-id="element-107">
          <motion.div className="flex gap-8" animate={{
          x: `calc(-${currentIndex * (100 / featuredServices.length)}% - ${currentIndex * 2}rem)`
        }} transition={{
          duration: 1,
          ease: 'easeInOut'
        }} data-id="element-108">
            {duplicatedServices.map((service, idx) => <div key={idx} className="flex-shrink-0 w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] bg-white p-10 rounded-[40px] shadow-xl shadow-slate-200/50 border border-slate-50 flex flex-col items-center text-center group hover:scale-[1.02] transition-transform duration-300" data-id="element-109">
                <div className={`w-32 h-32 ${service.bgColor} rounded-full flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500`} data-id="element-110">
                  <img src={service.icon} alt={service.title} className="w-20 h-20 object-contain" data-id="element-111" />
                </div>
                <h3 className="text-lg font-bold text-[#225274] mb-4 leading-tight break-words" data-id="element-112">
                  {service.title}
                </h3>
                <p className="text-slate-500 leading-relaxed" data-id="element-113">
                  {service.description}
                </p>
              </div>)}
          </motion.div>
        </div>

        {/* View All Services Button */}
        <div className="text-center" data-id="element-114">
          <a href="/services" className="inline-flex items-center gap-3 bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white px-12 py-5 rounded-full text-lg font-bold transition-all shadow-xl shadow-[#54c595]/30 group" data-id="element-115">
            VIEW ALL SERVICES
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-116" />
          </a>
        </div>
      </div>
    </section>;
}